<template>
    <u-btn-text-fit v-bind="$attrs" color="accent" @click="$emit('click')">
        <slot />
        <icon-arrow-primary class="ml-4px" />
    </u-btn-text-fit>
</template>

<script>
import UBtnTextFit from "@/components/publish/styles/buttons/u-btn-text-fit.vue";
import IconArrowPrimary from "@/components/publish/parents/icons/icon-arrow-primary.vue";

export default {
    props: {},
    components: {
        UBtnTextFit,
        IconArrowPrimary,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>
